import { MinzeElement } from 'minze'

export interface LvcCardPlaceholder {}

export class LvcCardPlaceholder extends MinzeElement {
  html = () => `
    <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="200" fill="#1E007D"/>
    </svg>
  `

  css = () => `
    
  `
}
